import { Stack, Typography } from '@mui/material';
import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import { capitalize, formatName, getPolicyStatus } from '../../../util/util';
import { StyledSectionContainer } from '../../common';
import DisplayCard from '../../DisplayCard';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import { getCurrentGraceLapse } from '../../search/util';

interface Props {
	cancellationData: CancellationData;
	authData: AuthData;
}

const CancellationOverview = (props: Props) => {
	const { authData, cancellationData } = props;
	const { policy, graceLapse, selectedCancellation } = cancellationData;
	if (!graceLapse) {
		return <LargeCenterSpinner />;
	}

	const state = getPolicyStatus(policy, getCurrentGraceLapse(graceLapse));

	const renderDetailCard = (title: string, data: string) => {
		return <DisplayCard title={title} value={data} />;
	};

	return (
		<StyledSectionContainer>
			<Stack spacing={2}>
				<Typography id='cancellation_id' variant='h3' gutterBottom>
					{`Cancellation ${selectedCancellation.locator}`}
				</Typography>
				<Stack direction='row' spacing={2}>
					{renderDetailCard('Policy Id', policy.displayId)}
					{renderDetailCard('Product', formatName(policy.productName))}
					{renderDetailCard(
						'Policy Created',
						authData.getFormattedDate(policy.createdTimestamp),
					)}
					{renderDetailCard('Policy State', state)}
					{renderDetailCard(
						'Cancellation Created',
						authData.getFormattedDate(selectedCancellation.createdTimestamp),
					)}
					{renderDetailCard(
						'Cancellation State',
						capitalize(selectedCancellation.state),
					)}
				</Stack>
			</Stack>
		</StyledSectionContainer>
	);
};

export default withCancellationContext<Props>(CancellationOverview);
